export const environment = {
  production: false,
  apiUrl: "https://server.demo.bdomobile.com/",
  keycloakUrl: "https://keycloak-dev.mobiletract.com",
  realm: "bdo-demo",
  tpayScript: "https://secure.tpay.com/groups-696041.js",
  clientId: "ekowitryna_admin_panel",
  googleTagManagerId: 'GTM-T43SC6BD',
  googleTagManagerPreview: 'env-3',
  googleTagManagerAuth: 'nwRCCNlB1-SPt0eiDeFIOw',
  enableDebugControls: false,
  signozUrl: "https://otlp.monitoring.mobiletract.com",
  signozEnv: "demo",
  signozServiceName: "ekowitryna-admin-panel_web",
  platformWebUrl: "https://platforma.demo.bdomobile.com",
  allowedReturnUrlOrigins: [
    'https://platforma.demo.bdomobile.com',
    'https://panel.demo.bdomobile.com',
    'https://kobize.ekowitryna.pl',
    'https://esg.dev2.bdomobile.com',
    'http://localhost:4200',
  ],
};
